module.exports = __webpack_public_path__ + "img/logo-small.6ebf7488.png";